// extracted by mini-css-extract-plugin
export var completionBody = "_ki-2";
export var completionCard = "_ki-0";
export var completionFooter = "_ki-3";
export var completionTitle = "_ki-1";